import Api from "../helpers/api";

export const vratDatagridData = async (data) => {
  try {
    const tab = data.get.tab ? `${data.get.tab}/` : "";
    let id = getId(data);
    const response = await Api.post(
      `/api/v1/smartmap/datatable/${data.get.type}/${tab}${id}`,
      data.post
    );
    return response || false;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Ziska data, ktore je potrebne zaroven stiahnut ako subor
 * Uzivatelovi rovno ponukne stiahnute suboru
 * @param {object} data
 * @param {string} fileName
 * @returns
 */
export const vratDatagridDataDownload = async (data, fileName) => {
  try {
    const tab = data.get.tab ? `${data.get.tab}/` : "";
    let id = getId(data);
    const response = await Api.post(
      `/api/v1/smartmap/datatable/${data.get.type}/${tab}${id}`,
      data.post,
      fileName
    );
    return response || false;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Ziska data, ktore je potrebne zaroven stiahnut ako subor
 * Uzivatelovi rovno ponukne stiahnute suboru
 * @param {object} data
 * @param {string} fileName
 * @returns
 */
export const vratExportLv = async (data, fileName) => {
  try {
    const tab = data.get.tab ? `${data.get.tab}/` : "";
    let id = getId(data);
    const response = await Api.post(
      `/api/v1/smartmap/datatable/exportlv/${id}`,
      data.post,
      fileName
    );
    return response || false;
  } catch (error) {
    console.error(error);
  }
};

function getId(data) {
  let id = "0";
  if (
    (Array.isArray(data.get.id) && data.get.id.length > 0) ||
    (!Array.isArray(data.get.id) && data.get.id)
  ) {
    id = data.get.id;
  }

  return id;
}
